import { receiveEntity } from './entities';
import MerchantRecord from '../records/merchant';

const type = 'merchants';

const path = (resource) => {
  if (!resource) resource = '';
  return { resource: 'api/' + type + '/' + resource };
};

export const getMerchant = (id) => {
  return (dispatch, getState, api) => {
    return api.get(path(id)).then((res) => dispatch(receiveEntity(res)));
  };
};

export const acceptMerchantInvite = (slug, company_id) => {
  return (dispatch, getState, api) => {
    return api
      .post(path('accept_merchant_company_connect_invite_new_company'), {
        slug,
        company_id,
      })
      .then((res) => new MerchantRecord(res.data.attributes));
  };
};
